import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import './clientCandidateStyle.css';
import { CVLeftContainer } from './cvLeftContainer';
import { CVRightContainer } from './cvRightContainer';
import ClientCandidateService from '../../../services/client-services/clientCandidateService';
import { decodeJWT } from '../../../services/candidateService';
import profilebackButtonIcon from '../../../assets/images/Ic_back.png';
import _ from 'lodash';

export const ClientCandidateInformation = () => {
  const [loader, setLoader] = useState(true);
  const [searchParams] = useSearchParams();
  const [candidateData, setCandidateData] = useState({});
  const [candidateStatus, setCandidateStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const [scoreRefreshTrigger, setScoreRefreshTrigger] = useState(0);

  const navigate = useNavigate();
  const refreshCandidate = async () => {
    try {
      setLoader(true);

      const decoded = decodeJWT(window.localStorage.getItem('authToken'));
      const clientId = _.get(decoded, 'clientId', '');
      const candidateId = searchParams.get('candidateId');

      const response = await ClientCandidateService.getCandidateById(
        clientId,
        candidateId
      );

      setCandidateData(response.data);
    } catch (err) {
      console.error('Failed to refresh candidate', err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const decoded = decodeJWT(window.localStorage.getItem('authToken'));
    const clientId = _.get(decoded, 'clientId', '');
    const candidateId = searchParams.get('candidateId');

    if (candidateId) {
      setLoader(true);
      ClientCandidateService.getCandidateById(clientId, candidateId)
        .then((response) => {
          setCandidateData(response.data);
          setLoader(false);
        })
        .catch((err) => {
          console.error(err);
          setLoader(false);
          const errorMessage = err?.response?.data?.message || 'An error occurred while fetching candidate data.';
          setErrorMessage(`Error: ${errorMessage}`);
        });
    }
  }, []);

  const refreshShortlistDetails = async () => {
    try {
      const decoded = decodeJWT(localStorage.getItem('authToken'));
      const clientId = _.get(decoded, 'clientId', '');
      const candidateId = searchParams.get('candidateId');

      const response = await ClientCandidateService.getCandidateById(
        clientId,
        candidateId
      );

      setCandidateData(prev => ({
        ...prev,
        shortlistDetails: response.data.shortlistDetails,
      }));
    } catch (err) {
      console.error('Failed to refresh shortlist details', err);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);
  return (
    <>
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {loader && (
        <div className="clientcandidate-loader-container">
          <div className="clientcandidate-loader"></div>
        </div>
      )}
      {!loader && candidateData && (
        <Container fluid className='cvleftrightcontainer'>
          <br></br>
          {/* Breadcrumb */}
          <div className="profile-work-experience-breadcrumb">
            <div
              className="breadcrumb-back"
              onClick={() => {

                const source = sessionStorage.getItem("candidateProfileSource");

                if (source === "CURATED_SHORTLISTED") {
                  sessionStorage.removeItem("candidateProfileSource");

                  navigate("/client/search-candidate");
                  return;
                }

                let navigationStack = JSON.parse(sessionStorage.getItem("navigationStack")) || [];

                navigationStack.push("ClientCandidateInfo");
                sessionStorage.setItem("navigationStack", JSON.stringify(navigationStack));


                navigate(-1, {

                  state: {
                    searchFilters: sessionStorage.getItem('searchFilters'),
                    filteredResults: sessionStorage.getItem('filteredResults'),
                    currentPage: sessionStorage.getItem('currentPage'),
                    totalPages: sessionStorage.getItem('totalPages'),
                    viewMode: sessionStorage.getItem('viewMode'),
                    searchFormData: sessionStorage.getItem('searchFormData'),
                    showResultsSection: sessionStorage.getItem('showResultsSection'),
                  }
                });
              }}
            >
              <img src={profilebackButtonIcon} alt="Back" className="breadcrumb-back-icon" />
              <span className="breadcrumb-back-text">Back</span>
            </div>
            <div className="breadcrumb-path">
              <span
                className="breadcrumb-link"
              >
                My Candidates
              </span>
              <span className="breadcrumb-separator">/</span>
              <span
                className="breadcrumb-link"
              >
                Search
              </span>
              <span className="breadcrumb-separator">/</span>
              <span className="breadcrumb-candidate-name">
                {_.get(candidateData, 'candidate.candidate.personalDetails.firstName')}{' '}
                {_.get(candidateData, 'candidate.candidate.personalDetails.lastName')}
              </span>
            </div>
          </div>
          <br></br>
          <Row className="client-candidate-information-row">
            <Col xs={12} xl={9} className="order-xl-first">
              <CVLeftContainer
                candidateData={_.get(candidateData, 'candidate')}
                candidateStatus={_.get(candidateData, 'shortlistDetails', {})}
                refreshCandidate={refreshCandidate}
                refreshShortlistDetails={refreshShortlistDetails}
                shortlistDetails={_.get(candidateData, 'shortlistDetails', [])}
                triggerScoreRefresh={() => setScoreRefreshTrigger(prev => prev + 1)}

              />
            </Col>
            <Col xs={12} xl={3} className="order-xl-last">
              <CVRightContainer candidateData={_.get(candidateData, 'candidate')} scoreRefreshTrigger={scoreRefreshTrigger} />
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};